
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AbstractLegend } from '@jeppesen-foreflight/jmkw-toolkit';
import { TimeSpanSelectComponent } from '../../../../twc-legend/components/time-span-select/time-span-select.component';
import { TwcTime } from '../../../../twc-time';
import { TwcLayerType } from '../../../../twc.mixin';
import { FlightRulesSvgComponent } from './flight-rules-svg/flight-rules-legend-svg';

@Component({
  selector: 'jmkw-flight-rules-legend',
  templateUrl: './flight-rules-legend.component.html',
  styleUrls: ['./flight-rules-legend.component.scss'],
  standalone: true,
  imports: [FlightRulesSvgComponent, TimeSpanSelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlightRulesLegendComponent
  extends AbstractLegend
  implements OnInit
{
  ifrLayer?: TwcLayerType;
  lifrLayer?: TwcLayerType;
  mvfrLayer?: TwcLayerType;

  get timeMultiplier() {
    return this.ifrLayer?.type === 'web-tile' ? 1000 : 1;
  }

  override ngOnInit() {
    super.ngOnInit();
    this.ifrLayer = this.toolkitApiService.getLayerById<TwcLayerType>('ifr');
    this.lifrLayer = this.toolkitApiService.getLayerById<TwcLayerType>('lifr');
    this.mvfrLayer = this.toolkitApiService.getLayerById<TwcLayerType>('mvfr');

    // Set up metadata watches for all layers
    this.setupLayersMetadataWatch();
  }

  updateSelectedTime(selectedTime: string) {
    [this.ifrLayer, this.lifrLayer, this.mvfrLayer].forEach((layer) => {
      if (layer) {
        layer.selectedTime = selectedTime;
      }
    });
  }

  /**
   * Set up metadata watches for all flight rules layers
   */
  private setupLayersMetadataWatch(): void {
    // Watch for metadata changes on all layers
    [this.ifrLayer, this.lifrLayer, this.mvfrLayer].forEach((layer) => {
      if (!layer?.metadata) return;

      const handle = this.setupWatch(
        () => layer.metadata?.['updatedAt'],
        (updatedAt: number) => this.handleMetadataUpdate(updatedAt)
      );

      if (handle) {
        this.watchHandles.add(handle);
      }
    });
  }

  /**
   * Handle metadata updates from any of the layers
   * @param updatedAt Timestamp when the data was updated
   */
  handleMetadataUpdate(updatedAt: number): void {
    if (!this.plugin?.legend?.legendTitleBarInfo) return;

    // Create a TwcTime instance with the updated timestamp
    const twcTime = new TwcTime(updatedAt);

    // Use the stringify method to format according to your standard
    // with the appropriate multiplier based on the layer type
    const formattedDate = twcTime.stringify(
      this.timeMultiplier,
      'dd/HH:mm',
      'UTC'
    );

    // Update the legend title bar with the formatted date
    this.plugin.legend.legendTitleBarInfo.set(formattedDate);
  }
}
